import { render, staticRenderFns } from "./newSales.vue?vue&type=template&id=3f89cd3c&"
import script from "./newSales.vue?vue&type=script&lang=js&"
export * from "./newSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports